export const isBrowser = () => typeof window !== 'undefined';

export const isIOS = () => isBrowser() && navigator && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
